/* eslint-disable no-open-modules-imports */

import type { FeatureGroup } from 'feature/feature-helpers';
import { COMPOSITE, SECTION } from 'feature/feature-helpers';
import {
    AccountEmailNotificationPermissionFeature,
    AccountEmailNotifModFeature,
    AccountEmailNotifReplyFeature,
} from 'open-modules/zdf/feature/account/account-email-notification-permission';
import { AccountNotificationPermissionFeature } from 'open-modules/zdf/feature/account/account-notification-permission';
import { AccountPushNotificationPermissionFeature } from 'open-modules/zdf/feature/account/account-push-notification-permission';
import { WarnBlockOverviewFeature } from 'open-modules/zdf/feature/account/account-warn-block-overview';
import { AccountVideoVotingSettingFeature } from 'open-modules/zdf/feature/videovoting/account-video-voting-setting';
import { t } from 'util/stdtypes';

import { AccountDeleteFeature } from './account-delete';
import { AccountRequestDataFeature } from './request-data';

export const accountFeatures: FeatureGroup[] = [
    SECTION(t('Account Management'), [
        COMPOSITE(AccountNotificationPermissionFeature, [
            AccountPushNotificationPermissionFeature,
            COMPOSITE(AccountEmailNotificationPermissionFeature, [AccountEmailNotifModFeature, AccountEmailNotifReplyFeature]),
        ]),
        AccountRequestDataFeature,
        AccountDeleteFeature,
        WarnBlockOverviewFeature,
    ]),
    SECTION(t('Account Settings'), [AccountVideoVotingSettingFeature]),
];

export const accountDefaultConfig = {
    profilerequestdata: true,
    profiledelete: true,
    notificationpermission: false,
    pushnotificationpermission: false,
    emailnotificationmoderation: false,
    emailnotificationreplies: false,
    emailnotificationpermission: false,
};
